<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
    <h1 class="headline pb-4 mx-lg-auto">{{ familyMember.title || 'New Family Member' }}</h1>
    <v-tabs v-model="tabs" background-color="transparent">
      <v-tab exact-path :to="'/family-members/' + familyMember.id">Details</v-tab>
      <v-tab exact-path :to="'/family-members/' + familyMember.id + '/history'" v-if="familyMember.id > 0"
        >History</v-tab
      >
    </v-tabs>
    <v-card>
      <v-card-text>
        <v-tabs-items v-model="tabs" transition="false">
          <v-card flat>
            <v-card-text>
              <router-view />
            </v-card-text>
          </v-card>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/store/index';

export default {
  name: 'FamilyMemberView',
  beforeRouteEnter(to, from, next) {
    store.dispatch('family/get', to.params.id).then(() => {
      next();
    });
  },
  computed: {
    ...mapGetters('family', ['loading', 'error', 'familyMember', 'meta'])
  },
  data() {
    return {
      tabs: null,
      breadcrumbs: [
        {
          text: 'Dashboard',
          exact: true,
          to: '/dashboard'
        },
        {
          text: 'Organisations',
          exact: true,
          to: '/organisations'
        },
        {
          text: 'Organisation',
          disabled: true,
          exact: true,
          to: '' // will be set in created/mounted
        },
        {
          text: 'Family Member',
          disabled: true,
          exact: true,
          to: '/family-members/:id'
        }
      ]
    };
  },
  watch: {
    familyMember: {
      handler() {
        this.updateOrganisationBreadcrumb();
      },
      immediate: true
    }
  },
  mounted() {
    this.updateOrganisationBreadcrumb();
  },
  methods: {
    updateOrganisationBreadcrumb() {
      // Try to get organisation_id from familyMember, fallback to route query
      const orgId = this.familyMember.organisation_id || this.$route.query.organisation_id;
      if (orgId) {
        // Update the Organisation breadcrumb link
        this.breadcrumbs = this.breadcrumbs.map(bc =>
          bc.text === 'Organisation' ? { ...bc, to: `/organisations/${orgId}`, disabled: false } : bc
        );
      }
    }
  }
};
</script>
